import axios from 'axios';

const API_BASE_URL = "https://ims.holdthechild.net";
// Make sure this is correct

export const fetchPayrolls = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_BASE_URL}/api/payroll`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data; // Assuming your backend returns an array directly
};

export const fetchPayslips = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_BASE_URL}/api/payroll`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data; // Assuming your backend returns an array directly
};

// New function to fetch payroll statistics
export const fetchPayrollStats = async () => {
  const token = localStorage.getItem("token");
  // The endpoint is /api/payroll/stats as defined in the controller
  const response = await axios.get(`${API_BASE_URL}/api/payroll/stats`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  // The backend now returns an object like { success: true, data: { ... } }
  // So we return the `data` property of the response data
  return response.data;
};
